import { RecordDashboard } from "../../applications";

const Home = () => {
  return <RecordDashboard />;
};

export default Home;
